
      <div class="row">
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Posted Tenders</h4>
              <h2 class="text-end"><span class="float-start">{{ postedTenders }}</span><i class="fas fa-ticket-alt"></i></h2>
              <p class="m-b-0">Navigate To Posted Tenders</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Pending Tenders</h4>
              <h2 class="text-end"><span class="float-start">{{ pendingTenders }}</span><i class="far fa-check-circle"></i></h2>
              <p class="m-b-0">Navigate To Pending Tenders</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Approved Tenders</h4>
              <h2 class="text-end"><span class="float-start">{{ approvedTenders }}</span><i class="fas fa-briefcase"></i></h2>
              <p class="m-b-0">Navigate To Approved Tenders</p>
            </div>
          </div>
        </div>
        <div class="col-lg-3 col-sm-6">
          <div class="info-box7 bg-c-purple order-info-box7">
            <div class="info-box7-block">
              <h4 class="m-b-20">Rejected Tenders</h4>
              <h2 class="text-end"><span class="float-start">{{ rejectedTenders }}</span><i class="fas fa-umbrella-beach"></i></h2>
              <p class="m-b-0">Navigate To Rejected Tenders</p>
            </div>
          </div>
        </div>
      </div>
      
     
    